import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function BenefitsSection() {
  const benefits = ['Más claridad sobre lo que le ocurre a tu cuerpo', 'Menos miedo a moverte en tu día a día', 'Sentirte acompañado/a por alguien que te entiende', 'Recuperar la esperanza en tu capacidad de sanar', 'Tener una guía de consulta a la que volver siempre', 'Paz mental al saber qué pasos dar'];
  return <section className="py-24 bg-warm-bg" data-id="element-54">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-55">
        <FadeIn data-id="element-56">
          <h2 className="text-3xl md:text-5xl font-heading text-warm-dark mb-12" data-id="element-57">
            Lo que te llevarás al leerlo
          </h2>

          <div className="grid sm:grid-cols-2 gap-6 text-left mb-16" data-id="element-58">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-warm-alt" data-id="element-59">
                <div className="w-2 h-2 rounded-full bg-warm-accent flex-shrink-0" data-id="element-60"></div>
                <span className="text-warm-dark font-medium" data-id="element-61">{benefit}</span>
              </div>)}
          </div>

          <Button href="#comprar" data-id="element-62">Empieza tu recuperación hoy</Button>
        </FadeIn>
      </div>
    </section>;
}